<section class="overlay-container">
  <mat-divider></mat-divider>
  <mat-action-list>
    @for (item of searches(); track item) {
      @if (hasStreet(item)) {
        <mat-list-item class="list" (click)="onItemClick(item)">
          <mat-icon matListItemIcon>location_on</mat-icon>
          <h3 matListItemTitle>{{ formatAddressToString(item) }}</h3>
        </mat-list-item>
      }
    }
  </mat-action-list>
</section>
